const Ball = ({ animated = false }: { animated: boolean }) => {
  if (animated) {
    return (
      <>
        <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="left-half">
              <rect x="0" y="0" width="4" height="8" />
            </clipPath>
            <clipPath id="right-half">
              <rect x="4" y="0" width="4" height="8" />
            </clipPath>
          </defs>
          <circle cx="4" cy="4" r="4" fill="blue" clipPath="url(#left-half)" />
          <circle cx="4" cy="4" r="4" fill="red" clipPath="url(#right-half)" />
        </svg>
      </>
    );
  } else {
    return (
      <>
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Union">
            <path
              d="M5.52271 2.56962C5.50646 2.53711 5.49015 2.52081 5.45765 2.4883L5.45766 2.48829C5.08937 2.01256 5.02517 1.5224 4.96444 1.05873C4.96081 1.03099 4.95718 1.00334 4.95351 0.975799C4.92095 0.715599 4.88844 0.47165 4.80713 0.2277C5.37633 0.0813166 5.94555 0 6.49851 0C7.47431 0 8.43387 0.2277 9.2958 0.634283C7.92968 1.07339 6.66115 1.72395 5.52271 2.56962Z"
              fill="#FF102C"
            />
            <path
              d="M10.0765 1.07341C10.4342 1.31736 10.7758 1.5938 11.0848 1.90282H11.0848C12.9551 3.7731 13.4593 6.48908 12.581 8.83099C12.5973 7.26972 11.9468 5.61088 10.9059 4.66758C9.9789 3.83817 8.90555 3.69179 7.96225 3.57797C7.23041 3.4804 6.56363 3.38277 6.02692 3.025C7.24667 2.13052 8.61278 1.47999 10.0765 1.07341Z"
              fill="#FF102C"
            />
            <path
              d="M7.86464 4.19595L7.85283 4.19433C7.0272 4.08104 6.18612 3.96563 5.47393 3.41528C5.18116 3.64298 4.88846 3.90318 4.5957 4.17963L11.2799 10.8639C12.4997 9.30258 11.8491 6.39144 10.4505 5.1229C9.6913 4.42836 8.77171 4.31137 7.88288 4.19828L7.86464 4.19596V4.19595Z"
              fill="#FF102C"
            />
            <path
              d="M4.17289 7.87146C4.07526 7.04203 3.94519 6.19636 3.39223 5.49701L3.39225 5.49703C3.61994 5.20426 3.88015 4.89524 4.1566 4.61879L10.8408 11.2868C9.27955 12.5065 6.36844 11.8722 5.09988 10.4736C4.41684 9.69295 4.28672 8.76594 4.17289 7.87146Z"
              fill="#FF102C"
            />
            <path
              d="M5.03479 2.95993C5.02666 2.94368 5.01446 2.93148 5.00226 2.91928C4.99006 2.90707 4.97786 2.89487 4.96973 2.87862C4.48183 2.22809 4.40051 1.5938 4.33545 1.05713C4.30294 0.829428 4.27038 0.618046 4.22162 0.439095C3.44096 0.715545 2.75793 1.15469 2.13992 1.70766L4.17283 3.74058C4.44933 3.44782 4.74203 3.18763 5.03479 2.95993Z"
              fill="#FF102C"
            />
            <path
              d="M2.93686 5.0579L2.85554 4.97659L2.85552 4.97655C2.22003 4.49996 1.61565 4.41132 1.07257 4.33168C1.05969 4.32979 1.04684 4.3279 1.03403 4.32602C0.806326 4.29351 0.611126 4.26101 0.415993 4.2122C0.70876 3.44781 1.13159 2.74853 1.68456 2.13049L3.70121 4.17967C3.42476 4.47244 3.16456 4.76514 2.93686 5.0579Z"
              fill="#FF102C"
            />
            <path
              d="M2.48147 5.48075C1.96781 5.09547 1.45409 5.02709 0.971698 4.96288L0.95272 4.96035C0.70877 4.92785 0.464821 4.89529 0.220871 4.83022C-0.185712 6.35897 -0.0230789 7.93652 0.643704 9.3189C1.08279 7.96902 1.73332 6.7005 2.57904 5.54581C2.54998 5.5361 2.53246 5.52065 2.51618 5.5063C2.50512 5.49654 2.49462 5.48729 2.48147 5.48069L2.48147 5.48075Z"
              fill="#FF102C"
            />
            <path
              d="M3.56189 8.00468C3.68984 8.95032 3.82999 9.98614 4.64448 10.8964L4.64449 10.8964C5.5715 11.921 7.19783 12.5716 8.72658 12.5716H8.82415C6.4985 13.4823 3.78253 12.9782 1.89598 11.0916C1.57071 10.7663 1.31052 10.4085 1.06657 10.0507C1.45688 8.58704 2.12367 7.25344 3.0019 6.01744C3.36704 6.54129 3.45324 7.1891 3.54789 7.90037C3.55021 7.9178 3.55253 7.93527 3.55487 7.95277C3.55721 7.97004 3.55955 7.98734 3.56189 8.00468Z"
              fill="#FF102C"
            />
          </g>
        </svg>
      </>
    );
  }
}

export default Ball;